import { useCallback } from 'react';
import { openNewWindow } from 'js/utils/url.util';
import { useShowNotification } from 'js/hooks/useShowNotification';

import * as Types from '../types';

export const useLaunchInNewWindow = () => {
    const showNotification = useShowNotification();

    const handlePopupBlocker = useCallback(() => {
        showNotification('playtech.mobile.system.games.popup-blocker', { variant: 'info' });
    }, [showNotification]);

    const openInExistingWindow = useCallback(({ gameWindow, launcherUrl }: Types.ILaunchInWindowParams): WindowProxy => {
        gameWindow.location.href = launcherUrl;
        gameWindow.focus();

        return gameWindow;
    }, []);

    return useCallback(({ launcherUrl, gameWindow }: Types.ILaunchInWindowParams): void => gameWindow
        ? openInExistingWindow({ gameWindow, launcherUrl })
        : openNewWindow(launcherUrl, '', undefined, handlePopupBlocker),
    [handlePopupBlocker, openInExistingWindow]);
};
